<template>
  <div
    class="d-block mb-3 mb-xl-8">
    <div
      class="d-flex align-center w-100 py-2 px-3 forgot-chip forgot-chip--error">
      <v-icon
        color="error"
        size="25">
        mdi-close-circle-outline
      </v-icon>
      <span class="text-validation error--text px-3">
        {{ text }}
      </span>
      <v-icon
        class="cs-pointer ml-auto"
        color="#A9A9A9"
        size="25"
        @click="$emit('update:show-error', false)">
        mdi-close
      </v-icon>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.forgot-chip {
  background-color: #f6f6f6;
  border: 1px solid transparent;
  border-radius: 4px;

  &--error {
    border-color: var(--v-error-base);
  }
}
</style>
